import React from 'react'
import styles from './index.module.css'
import type { UtilityClassNames } from '@s4l/utility-css'
import { cn } from '@s4l/utility-css'

interface DotsProps {
  className?: UtilityClassNames
  color?: string
  isInline?: boolean
  margin?: string
  top?: string
}

export function Dots({
  className,
  color,
  isInline = false,
  margin,
  top = '0',
}: Readonly<DotsProps>) {
  const containerStyle = {
    marginTop: top ? `${top}px` : undefined,
    margin: margin ? `${margin}px` : undefined,
  }

  const dotStyle = {
    backgroundColor: color || undefined,
  }

  return (
    <div
      className={cn(isInline ? styles.dotsLoaderInline : styles.dotsLoader, className)}
      style={containerStyle}
      data-testid="loader"
    >
      {Array.from({ length: 4 }, (_, index) => (
        <div key={index} className={styles.dot} style={color ? dotStyle : undefined} />
      ))}
    </div>
  )
}
